<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="420"
  >
    <v-card class="confirmation-dialog">
      <v-card-title class="text-h5" style="word-break: keep-all;">
        {{ confirmationDialog.header }}
      </v-card-title>
      <v-card-text>
        {{ confirmationDialog.body }}
        <v-otp-input
          v-if="requiresPin"
          id="otp-input"
          v-model="enteredPin"
          label="Ange admin pinkod"
          class="mt-6 mx-8"
          length="4"
          @finish="pinEntered"
        ></v-otp-input>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="error"
          text
          @click="show = false"
          :disabled="confirmationDialog.disableCancel"
        >
          Avbryt
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          @click="requiresPin ? pinEntered() : confirm()"
          color="success"
          text
          :disabled="isConfirmDisabled"
        >
          <span v-if="timeRemaining > 0" class="mr-2">({{ timeRemaining }})</span>
          <span>
            Bekräfta
          </span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import AuthService from '@/services/AuthService'
import { mapState } from 'vuex'

export default {
  name: 'ConfirmationDialog',
  data: () => ({
    endOfTimer: null,
    enteredPin: '',
    pinError: ''
  }),
  computed: {
    ...mapState(
      {
        confirmationDialog: state => state.confirmationDialog,
        now: state => state.now
      }
    ),
    requiresPin: function () {
      return this.confirmationDialog.requiresPin
    },
    isConfirmDisabled: function () {
      if (this.timeRemaining > 0) {
        return true
      }
      if (this.confirmationDialog.requiresPin) {
        return !this.enteredPin || this.enteredPin.length !== 4
      }
      return false
    },
    show: {
      get () {
        return this.confirmationDialog.show
      },
      set (value) {
        if (!value) {
          this.$store.commit('SET_CLOSE_CONFIRMATION_DIALOG')
        }
      }
    },
    timeRemaining: function () {
      if (this.confirmationDialog.withTimer && this.endOfTimer) {
        const diff = this.endOfTimer.diff(this.now, 'seconds')
        return diff || 0
      }
      return 0
    }
  },
  methods: {
    pinEntered: function () {
      if (!this.requiresPin || this.isConfirmDisabled) {
        return false
      }

      // bekräfta pinkod mot backend
      AuthService.verifyAuthCode({ authCode: this.enteredPin })
        .then(({ data }) => {
          if (data.status === 'success') {
            this.confirm()
          } else {
            this.$store.dispatch('snackbars/createSnackbar', {
              color: 'error',
              text: 'Felaktig pinkod'
            })
          }
          this.enteredPin = ''
          this.focusInput()
        })
    },
    confirm: function () {
      if (!this.confirmationDialog.confirmationFunction) {
        //
      } else if ((typeof this.confirmationDialog.confirmationFunction) === 'function') {
        this.confirmationDialog.confirmationFunction(this.confirmationDialog.confirmationArgument)
      } else {
        this.$store.dispatch(this.confirmationDialog.confirmationFunction, this.confirmationDialog.confirmationArgument)
      }
      this.show = false
    },
    focusInput: function () {
      const pinInput = document.querySelector('.confirmation-dialog input#otp-input--0')
      if (pinInput) {
        setTimeout(() => {
          pinInput.focus()
        }, 50)
      }
    }
  },
  watch: {
    'confirmationDialog.withTimer': function () {
      if (this.confirmationDialog.withTimer) {
        const duration = process.env.NODE_ENV === 'production' ? 10 : 3
        this.endOfTimer = this.now.clone().add(duration, 'seconds')
      }
    },
    'confirmationDialog.show': function (newVal) {
      if (!newVal) {
        // Dialog stängs
        this.enteredPin = ''
      } else {
        // Dialog öppnas
        if (this.requiresPin) {
          this.$nextTick(() => {
            this.focusInput()
          })
        }
      }
    }
  }
}
</script>
